import { SerializedStyles, css } from "@emotion/react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { Icon } from "components/icon";
import { withVar } from "themes/helpers";

interface IStyledItem {
  isMobile: boolean;
  active: boolean;
  counter?: boolean;
}

const linkCss = css`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: ${withVar(DesignToken.ContentInvertPrimary)};
  text-decoration: none;
  opacity: 0.6;
`;

const beamerBadgeCss = css`
  .beamer_icon.active {
    right: 12px !important;
    top: 4px !important;
    background-color: ${withVar(DesignToken.SurfaceAccentEmphasisHighNegative)} !important;
  }
`;

const linkInteractionCss = css`
  &.active,
  &:hover {
    background-color: rgb(43, 43, 46);
    opacity: 1;
  }

  &:active,
  &:focus {
    outline: none;
  }
`;

export const StyledItem = styled.div<IStyledItem>`
  ${(props): string => (props.isMobile ? "flex: 1" : "")};
  position: relative;
  height: 52px;
  text-align: center;
  font-size: 10px;
  ${(props): string => (props.active ? "cursor: pointer" : "")};
  ${(props): string =>
    !props.active
      ? `
  cursor: default;
  opacity: .24
`
      : ""};
  ${beamerBadgeCss}
`;

export const IconWrapper = styled.span`
  height: 24px;
  margin-bottom: 3px;
`;

export const FullscreenAppIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
`;

export const StyledNavLink = styled(NavLink)<{ counter?: boolean }>`
  ${linkCss};
  ${linkInteractionCss};
  ${(props): string => (props.counter ? `background-color: ${withVar(DesignToken.ActionNegativeActive)}` : "")};
`;

export const DivLink = styled.div<{ interactive?: boolean }>`
  ${linkCss};
  ${(props): SerializedStyles | undefined => (props.interactive ? linkInteractionCss : undefined)};
`;

export const StyledIcon = styled(Icon)`
  margin-bottom: 3px;
`;

export const BadgeContainer = styled.div`
  position: absolute;
  top: 4px;
  right: 12px;
`;

export const BadgeIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &::after {
    content: "";
    top: 0;
    width: 6px;
    height: 6px;
    background-color: ${withVar(DesignToken.ColorWhite)};
    border-radius: 50%;
  }
`;

export const ItemName = styled.span`
  display: inline-block;
  overflow: hidden;
  width: 95%;
  word-break: break-word;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const subscriptionCounterContainer = css`
  width: 100%;
  a:first-of-type {
    background-color: ${withVar(DesignToken.ActionNegativeDefault)};
    opacity: 1;
    :hover {
      background-color: ${withVar(DesignToken.ActionNegativeHover)};
    }
  }
`;

export const pointerOnHoverStyles = css`
  &:hover {
    cursor: pointer;
  }
`;

export const menuItemButtonStyles = css`
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  :hover {
    background-color: ${withVar(DesignToken.SurfacePrimaryHover)};
  }
  width: 100%;
`;

export const menuItemExternalLinkStyles = css`
  position: relative;
  display: block;
  text-align: left;
  padding: 10px 16px;
  font-size: 14px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  text-decoration: none;
  border: none;
  background-color: transparent;
  &:hover {
    background-color: ${withVar(DesignToken.SurfaceSecondaryHover)};
  }
`;

export const NavigationOption = styled.div`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing1});

  padding: 10px var(${SpacingToken.Spacing4});
`;
